//Staging URL
const url = "http://3.108.43.200:4001/"; //  Suraj url
export const API_BASE_URL = "http://3.108.43.200:4001/"; // Suraj's URL

const ApiConfig = {
  login: `${url}api/v1/user/login`,
  signup: `${url}api/v1/user/signup`,
  profile: `${url}api/v1/user/getProfile`,
  updateProfile: `${url}api/v1/user/updateProfile`,
  changePassword: `${url}api/v1/user/changePassword`,
  patientCreate: `${url}api/v1/user/admin/create`,
  doctorMain: `${url}api/v1/doctor/admin/list`,
  doctorAdd: `${url}api/v1/doctor/admin/create`,
  adminList: `${url}api/v1/user/admin/list`,
  doctoruserList: `${url}api/v1/doctor/list`,
  doctorDelete: `${url}api/v1/doctor/admin/delete`,
  doctorupdate: `${url}api/v1/doctor/admin/update`,
  createPlan: `${url}api/v1/plan/admin/create`,
  listPlan: `${url}api/v1/plan/admin/list`,
  listUserPlan: `${url}api/v1/plan/admin/purchase/list`,
  updatePlan: `${url}api/v1/plan/admin/update`,
  deletePlan: `${url}api/v1/plan/admin/delete`,
  uploadFile: `${url}api/v1/user/uploadFile`,
  adminUserList: `${url}api/v1/user/admin/list`,
  adminUserListUpdated: `${url}api/v1/user/admin/update`,
  adminUserListDelete: `${url}api/v1/user/admin/updateStatus`,
  createAdminSlot: `${url}api/v1/slot/admin/create`,
  createDoctorSlot: `${url}api/v1/slot/doctor/create`,
  listDoctorSlot: `${url}api/v1/slot/doctor/list`,
  editDoctorSlot: `${url}api/v1/slot/doctor/update`,
  deleteDoctorSlot: `${url}api/v1/slot/doctor/delete`,
  UserPlanList: `${url}api/v1/plan/list`,
  UserPlanPayment: `${url}api/v1/plan/purchase/paystack/initialize`,
  enableOrDisable2FA: `${url}api/v1/user/enableOrDisable2FA`,
  doctorslotUser: `${url}api/v1/slot/list`,
  appointmentBook: `${url}api/v1/appointment/book`,
  adminDashboard: `${url}api/v1/user/admin/dashboardCount`,
  verify2FA: `${url}api/v1/user/verify2FA`,
  contactUs: `${url}api/v1/contactUs/create`,
  adminListContactUs: `${url}api/v1/contactUs/admin/list`,
  userstaticList: `${url}api/v1/staticContent/list`,
  deletePlan: `${url}api/v1/plan/admin/delete`,
  uploadFile: `${url}api/v1/user/uploadFile`,
  adminUserList: `${url}api/v1/user/admin/list`,
  adminUserListUpdated: `${url}api/v1/user/admin/update`,
  adminUserListDelete: `${url}api/v1/user/admin/updateStatus`,
  createAdminSlot: `${url}api/v1/slot/admin/create`,
  createDoctorSlot: `${url}api/v1/slot/doctor/create`,
  listDoctorSlot: `${url}api/v1/slot/doctor/list`,
  editDoctorSlot: `${url}api/v1/slot/doctor/update`,
  deleteDoctorSlot: `${url}api/v1/slot/doctor/delete`,
  UserPlanList: `${url}api/v1/plan/list`,
  UserPlanPayment: `${url}api/v1/plan/purchase/paystack/initialize`,
  enableOrDisable2FA: `${url}api/v1/user/enableOrDisable2FA`,
  doctorslotUser: `${url}api/v1/slot/list`,
  appointmentBook: `${url}api/v1/appointment/book`,
  adminDashboard: `${url}api/v1/user/admin/dashboardCount`,
  adminCreateStatic: `${url}api/v1/staticContent/admin/create`,
  adminListStatic: `${url}api/v1/staticContent/admin/list`,
  adminUpdateStatic: `${url}api/v1/staticContent/admin/update`,
  adminDeleteStatic: `${url}api/v1/staticContent/admin/delete`,
  appointmentUserList: `${url}api/v1/appointment/list`,
  Appointinitialize: `${url}api/v1/appointment/payment/initialize`,
  Appointverify: `${url}api/v1/appointment/payment/verify`,
  Appointcancel: `${url}api/v1/appointment/cancel`,
  RoomChat: `${url}api/v1/chat/rooms`,
  messagesRoom: `${url}api/v1/chat/messages`,
  AdminAppoimmentList: `${url}api/v1/appointment/admin/list`,
  doctorAppointmentList: `${url}api/v1/appointment/doctor/history`,
  activePlan: `${url}api/v1/plan/purchase/activePlan`,
  upcomingListDoctor: `${url}api/v1/appointment/doctor/upcoming`,
  DoctorMarked: `${url}api/v1/appointment/doctor/complete`,
  medicalRecord: `${url}api/v1/medicalRecord/create`,
  medicalRecordList: `${url}api/v1/medicalRecord/list`,
  medicalRecordDoctorList: `${url}api/v1/medicalRecord/doctor/list`,
};
export default ApiConfig;
